export default __webpack_public_path__ + "static/media/img-48.9c7f15b7.jpg";